// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".square__container[data-v-25ab8e76]{width:80%;display:flex;flex-flow:column;padding-top:60px}.square__content-container[data-v-25ab8e76]{width:100%;display:flex;flex-flow:row wrap;align-items:center}", ""]);
// Exports
module.exports = exports;
